import React, { useRef, useEffect, useState } from "react";
import { Row, Col, Card, Typography, Select, Button, Pagination } from "antd";
import LeadCard from "./LeadCard";
import AdminCard from "./AdminCard";
import { FilterOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { fetchAdminAllLeads } from "../../store/action/admin/NewDashboardAction";
import "./newDashboard.css";
import * as type from "../../store/types";
import useLeadOptions from "../../components/NewDashboard/UseLeadOptions";
import axios from "../../store/api/axios";
import axiosNew from "../../store/api/axiosNew";

const AfterLoginWeb = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { Title } = Typography;
  const dispatch = useDispatch();
  const [selectedLead, setSelectedLead] = useState(null);
  const [cartLeads, setCartLeads] = useState([]);
  const [filters, setFilters] = useState({
    location: null,
    landType: null,
    budget: null,
    plotSize: null,
  });
  const filterLeads = location.state?.filters;
  const [filteredLeadsNav, setFilteredLeadsNav] = useState([]);
  // const [loadingFiltered, setLoadingFiltered] = useState(false);

  const rightColRef = useRef(null);
  const [rightColPos, setRightColPos] = useState({ left: 0, width: 0 });

  // Fetch leads on mount
  useEffect(() => {
    props.getAllAdminLeads_(1);
  }, []);

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        if (!token) return; // skip if not logged in

        const userId = localStorage.getItem("userId");
        const res = await axios.get(
          `https://stageapilead.blaccdot.com/api/cart/${userId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const backendCart =
          res.data.cart?.items?.map((i) => ({
            id: i.leadId,
            name: i.lead?.name,
            place: i.lead?.location,
            price: i.price,
            quantity: i.quantity,
          })) || [];

        setCartLeads(backendCart);
      } catch (err) {
        console.error("Failed to fetch cart", err);
      }
    };

    fetchCart();
  }, []);

  // Update right column position
  useEffect(() => {
    const updatePosition = () => {
      if (rightColRef.current) {
        const rect = rightColRef.current.getBoundingClientRect();
        setRightColPos({ left: rect.left, width: rect.width });
      }
    };
    updatePosition();
    window.addEventListener("resize", updatePosition);
    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  const fetchFilteredLeadsFromPage = async (filters) => {
    try {
      // setLoadingFiltered(true);

      const accessToken = localStorage.getItem("accessToken");
      const baseURL = "https://stageapilead.blaccdot.com/api/admin/all-lead";

      const params = {};
      if (filters?.area) params.search = filters.area;
      if (filters?.landType?.length > 0)
        params.category = filters.landType.join(",");
      if (filters?.budget?.length === 2) {
        params.minBudget = filters.budget[0];
        params.maxBudget = filters.budget[1];
      }
      if (filters?.plotSize?.length > 0)
        params.plotSize = filters.plotSize.join(",");

      const res = await axios.get(baseURL, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      const data = res.data?.data?.leads || [];
      setFilteredLeadsNav(data);
    } catch (err) {
      console.error("Error fetching filtered leads:", err);
      setFilteredLeadsNav([]);
    } finally {
      // setLoadingFiltered(false);
    }
  };

  useEffect(() => {
    if (filterLeads) {
      fetchFilteredLeadsFromPage(filterLeads);
    }
  }, [filterLeads]);

  const apiLeads = Array.isArray(props.allLeads) ? props.allLeads : [];
  const totalLeads = props.pagination?.total || 0;
  console.log("props", props);
  const pageSize = props.pagination?.limit || 10;

  const leads = apiLeads.map((lead) => ({
    id: lead._id,
    name: lead.name,
    place: lead.location,
    price: lead.budget,
    landType: lead.subcategory?.label || "",
    rating: `${lead.timesBought || 0}/${lead.leadAvailableCount || 0}`,
    status: lead.status || "",
    siteVisit: lead.siteVisitDays?.join(", ") || "",
    lookingFor: lead.property_details || "",
    contact: lead.phone,
    type: lead.leadType,
    category: lead.category,
    sqft: lead.spaceSqft || 0,
    subCategoryId: lead.subcategory?._id,
    subCategoryLabel: lead.subcategory?.label || "",
    subCategoryName: lead.subcategory?.name || "",
  }));

  // Priority lead
  const priorityLead = leads.find((lead) => {
    const [purchased, total] = (lead.rating || "0/0").split("/").map(Number);
    return total - purchased === 1;
  });

  const adminLead = priorityLead
    ? priorityLead
    : leads[Math.floor(Math.random() * leads.length)] || {};

  const {
    subCategoryOptions,
    locationOptions,
    landTypeOptions,
    budgetOptions,
    plotSizeOptions,
  } = useLeadOptions(leads);

  // Filtered leads
  const filteredLeads = leads.filter((lead) => {
    return (
      (!filters.location ||
        filters.location.length === 0 ||
        filters.location.includes(lead.place)) &&
      (!filters.landType ||
        filters.landType.length === 0 ||
        filters.landType.includes(lead.landType)) &&
      (!filters.budget ||
        filters.budget.length === 0 ||
        filters.budget.some((b) => Number(lead.price) <= Number(b))) &&
      (!filters.plotSize ||
        filters.plotSize.length === 0 ||
        filters.plotSize.some((s) => Number(lead.sqft) >= Number(s)))
    );
  });

  const handleBuyNow = (lead) => {
    // find the SAME lead object from the leads list
    const matchedLead = leads.find((l) => l.id === lead.id);

    if (matchedLead) {
      handleLeadCheck(matchedLead, true);
      setSelectedLead(matchedLead); // optional but recommended
    }
  };

// ... existing imports

const handleLeadCheck = async (lead, isChecked) => {
  // 1. Update UI immediately (Optimistic UI)
  if (isChecked) {
    setCartLeads((prev) => {
      if (prev.some((l) => l.id === lead.id)) return prev;
      return [...prev, lead];
    });

    try {
      // ✅ Use axiosNew (Interceptors handle the token automatically)
      // Remove the full URL, use the relative path
      await axiosNew.post("cart/add", { leadId: lead.id });
    } catch (err) {
      console.error("Failed to sync add to backend", err);
      // Rollback UI if the backend rejects it (e.g., 401 error)
      setCartLeads((prev) => prev.filter((l) => l.id !== lead.id));
    }
  } else {
    setCartLeads((prev) => prev.filter((l) => l.id !== lead.id));
    try {
      const userId = localStorage.getItem("userId");
      await axiosNew.delete(`cart/${userId}/${lead.id}`);
    } catch (err) {
      console.error("Failed to sync remove to backend", err);
    }
  }
};

const handleAddToCart = async () => {
  if (cartLeads.length === 0) return;

  try {
    
    navigate("/my-cart"); 
  } catch (error) {
    console.error("❌ Navigation failed:", error);
  }
};

  const handleFilter = () => navigate("/dashboard-filter");
  const handleClearSearchFilter = () => {
    setFilters({
      location: [],
      landType: [],
      budget: [],
      plotSize: [],
    });
    navigate("/admin/after-login-web", { replace: true, state: {} });
  };

  const groupedBySubCategory = React.useMemo(() => {
    if (!Array.isArray(leads) || leads.length === 0) return {};

    return leads.reduce((acc, lead) => {
      const label = lead.subCategoryLabel;

      if (!acc[label]) {
        acc[label] = [];
      }

      acc[label].push(lead);
      return acc;
    }, {});
  }, [leads]);

  const subCategoryCards = Object.entries(groupedBySubCategory).map(
    ([subCategory, leads]) => ({
      subCategory,
      count: leads.length,
      leads,
    })
  );

  const leadsToRender =
    filteredLeadsNav.length > 0 ? filteredLeadsNav : filteredLeads;
  // useEffect(() => {
  //   if (props.pagination?.page) {
  //     setCurrentPage(props.pagination.page);
  //   }
  // }, [props.pagination?.page]);
  console.log("🔵 UI PAGINATION PROPS:", props.pagination);

  // const handleAddToCart = async () => {
  //   if (cartLeads.length === 0) return;

  //   try {
  //     const accessToken = localStorage.getItem("accessToken");

  //     for (const lead of cartLeads) {
  //       const res = await axios.post(
  //         "https://stageapilead.blaccdot.com/api/cart/add/",
  //         { leadId: lead.id },
  //         {
  //           headers: {
  //             Authorization: `Bearer ${accessToken}`,
  //           },
  //         }
  //       );
  //       if (res.data?.cart?.userId) {
  //         localStorage.setItem("userId", res.data.cart.userId);
  //       }
  //     }

  //     // alert("✅ Leads added to cart successfully");

  //     // Optional UX improvements
  //     setCartLeads([]); // clear cart UI
  //     navigate("/admin/my-cart"); // go to cart page
  //   } catch (error) {
  //     console.error("❌ Add to cart failed:", error);
  //     alert("Failed to add some leads to cart");
  //   }
  // };

  return (
    <div style={{ padding: "10px" }}>
      {/* Page Title & Filters */}
      <Row gutter={16} align="middle" style={{ marginBottom: "16px" }}>
        <Col
          span={7}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Title level={4}>All Leads</Title>

          <Button type="primary" onClick={() => navigate("/admin/bulk-upload")}>
            Bulk Upload
          </Button>
        </Col>

        <Col span={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #DBEAFF",
              borderRadius: 6,
              overflow: "hidden",
              background: "#fff",
              width: "100%",
            }}
          >
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Select Location"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              value={filters.location}
              onChange={(value) =>
                setFilters((prev) => ({ ...prev, location: value }))
              }
              options={locationOptions}
            />

            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Land Type"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              value={filters.landType}
              onChange={(value) => setFilters({ ...filters, landType: value })}
              options={landTypeOptions}
            />
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Budget Range"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              value={filters.budget}
              onChange={(value) => setFilters({ ...filters, budget: value })}
              options={budgetOptions}
            />
            <Select
              mode="multiple"
              className="custom-select"
              placeholder="Plot Size"
              style={{ flex: 1, borderRight: "1px solid #DBEAFF" }}
              value={filters.plotSize}
              onChange={(value) => setFilters({ ...filters, plotSize: value })}
              options={plotSizeOptions}
            />
            <Button
              type="primary"
              style={{
                background: "blue",
                border: "none",
                borderRadius: 0,
                padding: "0 24px",
              }}
            >
              Search
            </Button>
          </div>
        </Col>
        <Col span={2} style={{ paddingRight: 0 }}>
          <Button
            type="default"
            onClick={handleClearSearchFilter}
            style={{ border: "1px solid red", color: "red" }}
          >
            Clear
          </Button>
        </Col>
        <Col span={2}>
          <Button
            icon={<FilterOutlined />}
            type="default"
            onClick={handleFilter}
          >
            Filter
          </Button>
        </Col>
      </Row>

      {/* Leads & Admin Card */}
      <Row gutter={20}>
        <Col span={7}>
          {leadsToRender.map((lead) => (
            <LeadCard
              key={lead.id}
              {...lead}
              showCheckbox={true}
              checked={cartLeads.some((l) => l.id === lead.id)}
              onCheck={(id, checked) => handleLeadCheck(lead, checked)}
              onClick={() =>
                setSelectedLead({
                  ...lead,
                })
              }
              isSelected={selectedLead?.id === lead.id}
            />
          ))}

          <Pagination
            current={props.pagination?.page || 1}
            total={props.pagination?.total || 0}
            pageSize={props.pagination?.limit || 10}
            onChange={(page) => props.getAllAdminLeads_(page)}
          />
        </Col>

        <Col flex="2px">
          <div
            style={{ width: 2, backgroundColor: "#DBEAFF", height: "100%" }}
          />
        </Col>

        <Col span={16} ref={rightColRef}>
          {selectedLead ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 12,
                }}
              >
                <Typography.Title level={4} style={{ margin: 0 }}>
                  Lead Details
                </Typography.Title>

                <Select
                  placeholder="Update Subcategory"
                  // value={selectedLead?.subCategoryId}

                  value={selectedLead?.subCategoryLabel?.toLowerCase()}
                  style={{ width: 220 }}
                  options={subCategoryOptions}
                  onChange={(selectedValue) => {
                    // Find the selected subcategory object from options
                    const selectedOption = subCategoryOptions.find(
                      (opt) => opt.value === selectedValue
                    );

                    if (!selectedOption) return;
                    console.log("Update payload:", {
                      id: selectedLead.id,

                      subcategory: selectedValue,
                    });
                    // Dispatch the update action
                    dispatch({
                      type: type.UPDATE_LEAD,
                      payload: {
                        id: selectedLead.id, // lead id in URL
                        payload: {
                          // subcategory: selectedOption.label.toLowerCase(),

                          subcategory: selectedValue,
                        },
                      },
                    });

                    // Immediately update local state so dropdown shows new selection
                    setSelectedLead((prev) => ({
                      ...prev,
                      subCategoryLabel: selectedValue,
                      subCategoryName: selectedValue,
                    }));
                  }}
                />
              </div>

              <Card
                style={{
                  borderRadius: 6,
                  background: "#fafafa",
                  marginBottom: 20,
                }}
              >
                <Row gutter={0}>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Name</strong>
                    <p>{selectedLead.name}</p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Looking For</strong>
                    <p>{selectedLead.lookingFor}</p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Sq.ft</strong>
                    <p>{selectedLead.sqft}</p>
                  </Col>
                  <Col span={6} className="col-padding">
                    <strong>Location</strong>
                    <p>{selectedLead.place}</p>
                  </Col>
                </Row>
                <Row gutter={0} style={{ marginTop: 10 }}>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Contact No.</strong>
                    <p>{selectedLead.contact}</p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Budget</strong>
                    <p>{selectedLead.price}</p>
                  </Col>
                 <Col span={6} className="search-select-divider col-padding">
  <strong>Preferred location</strong>
  <p>
    {selectedLead?.state || ''}-
    {selectedLead?.district || ''}-
    {selectedLead?.area || ''}--
    {selectedLead?.pincode || ''}
  </p>
</Col>

                  <Col span={6} className="col-padding">
                    <strong>Site Visit</strong>
                    <p>{selectedLead.siteVisit}</p>
                  </Col>
                </Row>

                <Button
                  style={{ background: "blue", color: "white", marginTop: 16 }}
                  onClick={() => handleLeadCheck(selectedLead, true)}
                >
                  Buy Now
                </Button>
              </Card>
            </>
          ) : (
            <AdminCard
              {...adminLead}
              // onBuyNow={handleBuyNow}
            />
          )}
          <div
            style={{
              display: "flex",
              gap: "16px",
              overflowX: "auto",
              paddingBottom: "8px",
            }}
          >
            {subCategoryCards.map(({ subCategory, leads }) => (
              <div
                key={subCategory}
                style={{
                  minWidth: 300,
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <h5>
                  {subCategory} ({leads.length})
                </h5>

                {leads.map((lead) => (
                  <LeadCard key={lead.id} {...lead} showCheckbox={false} />
                ))}
              </div>
            ))}
          </div>
        </Col>
      </Row>

      {/* Fixed cart */}
      {cartLeads.length > 0 && (
        <div
          style={{
            position: "fixed",
            bottom: 20,
            left: rightColPos.left,
            width: rightColPos.width,
            background: "#fff",
            border: "1px solid #64a1f7ff",
            borderRadius: 8,
            padding: "12px 16px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            zIndex: 1000,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <span style={{ color: "#007bff", fontSize: 16, fontWeight: 600 }}>
              No. of {cartLeads.length === 1 ? "lead" : "leads"} Selected:{" "}
              {cartLeads.length}
            </span>
            <span style={{ color: "#555", fontSize: 13 }}>
              * Lead amount may change while someone purchases the same lead at
              a time
            </span>
          </div>
          {/* <Button
            type="primary"
            onClick={() => navigate("/admin/my-cart", { state: { cartLeads } })}
          >
            Add to Cart
          </Button> */}
          <Button type="primary" onClick={handleAddToCart}>
            Add to Cart
          </Button>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  allLeads: state.adminAllLeads.response,
  pagination: state.adminAllLeads.pagination,
  loading: state.adminAllLeads.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getAllAdminLeads_: (page = 1) =>
    dispatch({ type: type.FETCH_ADMIN_ALL_LEADS, payload: { page } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AfterLoginWeb);
